import React from 'react'

const ControlButton = ({text, onClick, background, icon}) => {
    return (
        <button onClick={onClick} className={'text-sm md:text-base w-[25%] md:w-[70%] mx-auto p-3 my-4 rounded-2xl shadow shadow-xl hover:shadow-2xl duration-300 ' + background}>
            <div className='flex flex-row w-full justify-center relative z-0'>
                {text}
                {icon}
            </div>

        </button>
    );
}
 
export default ControlButton;